<template>
    <div v-show="visible">
        <el-dialog title="查看全景图" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose"  width="500px">    
            <div>
                <div v-if="form.imageUrl != null && form.imageUrl != ''">
                    <el-popover
                        placement="right"
                        title=""
                        trigger="hover">
                        <img :src="form.imageUrl" lazy="loading"
                            style="max-height:1000px; max-width:1200px"/>
                        <img slot="reference" :src="form.imageUrl"  lazy="loading" :alt="form.imageUrl" style="max-height: 250px;max-width: 680px">
                    </el-popover>
                </div>
                <div v-else>
                    无图片
                </div>
            </div> 

            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="visible=false">关闭</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import {banBackSpace} from '../../../../common/preventBackspace';// backspace退格

    export default {
        data(){
            return{
                visible: false,
                form:{
                    deptId:"",
                    classId:"",
                    classTimeId:"",
                    workDate:"",
                    imageUrl:""
                },
            }
        },
        created:function () {
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(data,deptId){
                this.visible=true;
                this.form.deptId=deptId;
                this.form.classId=data.classId;
                this.form.classTimeId=data.classTimeId;
                this.form.workDate=data.workDate;
                this.form.imageUrl="";
                // 初始图片
                this.initImage();
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            initImage(){
                let url  = this.getClassPictureUrl;
                let data = {
                    deptId:this.form.deptId,
                    classId:this.form.classId,
                    classTimeId:this.form.classTimeId,
                    workDate:this.form.workDate
                };       
                // console.log(JSON.stringify(data))
                this.apiPost(url,data).then((res) => {
                    console.log();
                    if(res.status==200){
                        this.form.imageUrl=res.data.imageUrl;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    this.loading=false;
                });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
   .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }  
</style>


// WEBPACK FOOTER //
// src/components/page/count/student/ShowClassPicture.vue